import { Link } from "react-router-dom";
import React from 'react'
import MaterialTable from "material-table";
import tableIcons from "../../resources/tableIcons";
import { APPLINKS } from "../../resources/AppConst";
import { loadingController } from '@ionic/core'
import { create, eye, print, trash } from "ionicons/icons";
import { IonIcon, useIonAlert } from "@ionic/react";

const InvoiceTable = ({ data, printBill, editBill, removeBill, viewBill }) => {
    const [presentAlert , dissmissAlert] = useIonAlert();
    const columns = [
        {
            title: 'Bill No.',
            field: 'invoiceNo',
        },
        {
            title: 'Bill Date',
            field: 'billDate',
            type: 'date',
        },
        {
            title: 'Customer',
            field: 'customerName',
            render: (rowData) => {
                return (
                    <Link
                        to={`${APPLINKS.ledger}/${btoa(rowData.customerName)}`}
                        onClick={() => {
                            loadingController.create({
                                id: "ledgerLoad",
                                message: "Loading...",
                                mode: "md",
                                spinner: "crescent"
                            }).then(spin => {
                                spin.present();
                            })
                        }}
                    ><span style={{ textTransform: 'capitalize' }}>{rowData.customerName}</span></Link>
                )
            }
        },
        {
            title: 'No. of Products',
            field: 'products.length',
        },
        {
            title: 'Taxable Amount',
            field: 'subtotalAmt',
            type: 'currency',
            currencySetting: {
                currencyCode: 'INR',
            }
        },
        {
            title: 'Total Amount',
            field: 'totalAmt',
            type: 'currency',
            currencySetting: {
                currencyCode: 'INR',
            }
        }
    ];

    return (
        <MaterialTable columns={columns} icons={tableIcons}
            options={{
                headerStyle: {
                    backgroundColor: '#989aa2',
                    color: '#FFF',
                },
                actionsColumnIndex: -1,
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100],
                columnsButton: true,
                exportButton: true,
                selection: true, // enable selection
                exportFileName: 'Invoice List',
            }}
            data={data}
            actions={[
                {
                    icon: () => <IonIcon icon={print}></IonIcon>,
                    tooltip: 'Print Bill',
                    onClick: (event, rowData) => {
                        printBill(rowData)
                    },
                    position: 'row'
                },
                {
                    icon: () => <IonIcon icon={eye}></IonIcon>,
                    tooltip: 'View Bill',
                    onClick: (event, rowData) => {
                        viewBill(rowData)
                    },
                    position: 'row'
                },
                {
                    icon: () => <IonIcon icon={create}></IonIcon>,
                    tooltip: 'Edit Bill',
                    onClick: (event, rowData) => {
                        editBill(rowData)
                    },
                    position: 'row'
                },
                {
                    icon: () => <IonIcon icon={trash}></IonIcon>,
                    tooltip: 'Delete Bill',
                    onClick: (event, rowData) => {
                        presentAlert({
                            header: 'Delete Bill',
                            message: 'Are you sure you want to delete this bill?',
                            buttons: [
                                {
                                    text: 'Cancel',
                                    role: 'cancel',
                                    cssClass: 'cancel-text',
                                    handler: () => {
                                        dissmissAlert();
                                    }
                                },
                                {
                                    text: 'Delete',
                                    role: 'destructive',
                                    cssClass: 'red',
                                    handler: () => {
                                        removeBill(rowData.invoiceId)
                                    }
                                }
                            ]
                        })
                    },
                    position: 'row'
                },
                {
                    icon: () => <IonIcon icon={trash}></IonIcon>,
                    tooltip: 'Delete Selected Bills',
                    onClick: (event, data) => {
                        presentAlert({
                            header: 'Delete Selected Bills',
                            message: 'Are you sure you want to delete selected bills?',
                            buttons: [
                                {
                                    text: 'Cancel',
                                    role: 'cancel',
                                    cssClass: 'cancel-text',
                                    handler: () => {
                                        dissmissAlert()
                                    }
                                },
                                {
                                    text: 'Delete',
                                    role: 'destructive',
                                    cssClass: 'red',
                                    handler: () => {
                                        dissmissAlert()
                                        data.forEach(bill => {
                                            removeBill(bill.invoiceId)
                                        });
                                    }
                                }
                            ]
                        })
                    },
                    position: "toolbarOnSelect"
                }

            ]}
            title="Invoices" />
    )
}

export default InvoiceTable
